export default __webpack_public_path__ + "static/media/PASTILLEKOJY-BOT.81e80221.png";